<div>
  <div class="text-left">
    <strong>{{ title }}</strong>
  </div>
  <hr />

  <!-- Error message if JSON parsing failed -->
  <div *ngIf="parseError" class="alert alert-danger">
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
    <strong>{{ parseError }}</strong>
    <div *ngIf="data.jsonString" class="mt-2">
      <strong>Raw Data:</strong>
      <pre class="bg-white p-2 border rounded pre-scrollable small">{{
        data.jsonString
      }}</pre>
    </div>
  </div>

  <!-- Map link if coordinates are available -->
  <div
    *ngIf="coordinates && !parseError"
    class="d-flex align-items-center justify-content-between mb-3 px-3"
  >
    <div class="d-flex align-items-center gap-2">
      <a href="javascript:void(0)" class="text-primary" (click)="openInMaps()">
        <i class="fa fa-map-marker" aria-hidden="true"></i>
        View Location on Map
      </a>&nbsp;
      <a
        href="javascript:void(0)"
        [appCopyToClipboard]="mapUrl"
        matTooltip="Copy Map Link"
        class="ms-1"
      >
        <i class="fa fa-copy" aria-hidden="true"></i>
      </a>
    </div>
  </div>

  <!-- Display parsed JSON data -->
  <div *ngIf="!parseError && parsedData" class="px-3 py-2 json-scroll">
    <ng-container
      *ngTemplateOutlet="jsonRenderer; context: { data: parsedData, level: 0 }"
    ></ng-container>
  </div>

  <!-- Recursive template for rendering JSON -->
  <ng-template #jsonRenderer let-data="data" let-level="level">
    <div class="table-responsive" [style.margin-left.px]="level * 20">
      <table class="table table-borderless table-sm">
        <tbody>
          <ng-container *ngFor="let key of getKeys(data)">
            <!-- Primitive values (string, number, boolean, null) -->
            <tr *ngIf="isPrimitive(data[key])" class="border-bottom">
              <td class="text-muted json-label-cell">
                {{ formatKey(key) }}
              </td>
              <td class="json-value-cell">
                <span [ngClass]="getValueClass(data[key])">
                  {{ formatValue(data[key]) }}
                </span>
              </td>
            </tr>

            <!-- Array values -->
            <tr *ngIf="isArray(data[key])" class="border-bottom">
              <td class="text-muted json-label-cell">
                {{ formatKey(key) }}
              </td>
              <td class="json-value-cell">
                <div class="d-flex flex-column">
                  <div
                    *ngFor="let item of data[key]; let i = index"
                    class="mb-1"
                  >
                    <ng-container *ngIf="isPrimitive(item)">
                      <span [ngClass]="getValueClass(item)">
                        {{ formatValue(item) }}
                      </span>
                    </ng-container>
                    <ng-container *ngIf="isObject(item)">
                      <div class="ps-3 border-start border-2">
                        <ng-container
                          *ngTemplateOutlet="
                            jsonRenderer;
                            context: { data: item, level: level + 1 }
                          "
                        ></ng-container>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </td>
            </tr>

            <!-- Nested objects -->
            <tr *ngIf="isObject(data[key])">
              <td colspan="2" class="p-0">
                <div class="my-3">
                  <div class="fw-bold border-bottom pb-2 mb-2">
                    {{ formatKey(key) }}
                  </div>
                  <ng-container
                    *ngTemplateOutlet="
                      jsonRenderer;
                      context: { data: data[key], level: level }
                    "
                  ></ng-container>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </ng-template>

  <hr />
  <div class="text-right">
    <button
      type="button"
      mat-raised-button
      color="secondary"
      (click)="onClose()"
      title="Close"
    >
      Close
    </button>
  </div>
</div>
